import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantFile } from '../mutations/deleteParticipantFile.mutation';
import type {
  DeleteParticipantFileMutation,
  DeleteParticipantFileMutationVariables,
} from '../types';

export const useDeleteParticipantFileMutation = (
  options?: MutationOptions<DeleteParticipantFileMutation, DeleteParticipantFileMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantFile), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
